import React from "react"
import { ApolloProvider } from "react-apollo"
import { Provider } from "react-redux"

import { ApolloProvider as ApolloHooksProvider } from "@apollo/react-hooks"

import { createApolloClient } from "./graphql"
import { createStore } from "./state"

// eslint-disable-next-line react/prop-types
const wrapRootElement = ({ element }) => {
  const apolloClient = createApolloClient()
  const store = createStore()
  return (
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <ApolloHooksProvider client={apolloClient}>
          {element}
        </ApolloHooksProvider>
      </ApolloProvider>
    </Provider>
  )
}

export default wrapRootElement
